import BroadLineOfBusinessDetails from './BroadLineOfBusinessDetails';
import PerilDeductible from './PerilDeductible';
import PolicyCost from './PolicyCost';
import InsuredInfoOfac from './InsuredInfoOfac';
import MortgageeWithStatus from './MortgageeWithStatus';
import ProducerInfo from './ProducerInfo';
import {
	BuildingResponseCommercialExistingWithStatus,
	BuildingResponsePersonalWithStatus,
} from '@app/models/api';

export default class PublicPolicyViewData {
	public id: number | null = null;
	public productCode: string | null = null;
	public broadLineOfBusiness: BroadLineOfBusinessDetails | null = null;
	public perilsDeductibles: PerilDeductible[] = [];
	public cost: PolicyCost | null = null;
	public producer: ProducerInfo | null = null;
	public namedInsured: InsuredInfoOfac | null = null;
	public mortgagees: MortgageeWithStatus[] = [];
	public risk: BuildingResponsePersonalWithStatus | null = null;
	public risks: BuildingResponseCommercialExistingWithStatus[] = [];

	public constructor() {

	}
};